import { createFileRoute, redirect } from "@tanstack/react-router";

/** Flyttad till ordlistan – permanent omdirigering. */
export const Route = createFileRoute("/elpriser/nordpool")({
  beforeLoad: () => {
    throw redirect({ to: "/ordlista/$term", params: { term: "nord-pool" }, statusCode: 301 });
  },
});
